import { useLayoutEffect } from 'react';

/**
 * Holds body scroll while an overlay is open, and — importantly — restores
 * whatever the previous value was rather than blindly clearing it, so two
 * overlays open at once can't leave the page permanently unscrollable.
 */
export function useLockBodyScroll(locked) {
  useLayoutEffect(() => {
    if (!locked) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [locked]);
}
